import { Button } from '@/components/Button/Button'
import React from 'react'
import { cn } from '@/lib/utils'

export const NextStep = ({
  onNextStep,
  disabled,
  isStatic,
  text,
}: {
  onNextStep: () => void
  disabled?: boolean
  isStatic?: boolean
  text?: string
}) => {
  return (
    <div
      className={cn('pt-[100px] px-5 relative z-20', {
        'pt-[20px]': isStatic,
      })}
    >
      <div
        className={cn('fixed bottom-0 py-2 p-5 bg-black w-full left-0 flex justify-center', {
          relative: isStatic,
        })}
      >
        <Button
          className=" max-w-full w-[400px] font-semibold"
          onClick={() => {
            onNextStep()
          }}
          disabled={disabled}
          variant="multistep"
        >
          {text}
        </Button>
      </div>
    </div>
  )
}
